export default "__VITE_ASSET__e9fbaa9e__"